import { useMutation } from '@tanstack/react-query';
import { toast } from '../../../lib/toast';
import { exportDailyTaskTrackingPdf } from '../api/dailyTaskTracking';
import type { GetDailyTaskTrackingParams } from '../api/dailyTaskTracking';

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function useExportDailyTaskTrackingPdf() {
  return useMutation({
    mutationFn: (params: GetDailyTaskTrackingParams) => exportDailyTaskTrackingPdf(params),
    onSuccess: (blob) => {
      const date = new Date().toISOString().slice(0, 10);
      downloadBlob(blob, `daily-task-tracking-report-${date}.pdf`);
      toast.success('Daily Task Tracking report exported as PDF successfully');
    },
    onError: (err: unknown) => {
      const axiosErr = err as { response?: { data?: { detail?: string; title?: string } } };
      const detail = axiosErr.response?.data?.detail ?? axiosErr.response?.data?.title;
      toast.error(detail ?? 'Failed to export Daily Task Tracking report as PDF');
    },
  });
}
